import create from "zustand";
import PersistentAppState from "./PersistentAppState";

export const useUserStore = create(PersistentAppState);
